import React from "react";
import moment from "moment";

const RelatorioProcedimentosRealizadosContent = ({ dadosRelatorio, filters , utilizaValorCusto }) => {
  const columnColor = (index) => {
    if (index % 2 !== 0) {
      return { backgroundColor: "#F2F2F2" };
    }
    return "";
  };

  const {
    dataInicio,
    dataFim,
    profissionalSaude,
    convenio,
    procedimento,
    faturado,
  } = filters || {};

  return (
    <>
      <div style={styles.titulo}>Relatório de Procedimentos agendados</div>
      <div style={styles.subTitulo}>
        {dataInicio && (
          <div>
            Data início:
            <span>{moment(dataInicio).format("DD/MM/YYYY")}</span>
          </div>
        )}
        {dataFim && (
          <div>
            Data fim:
            <span>{moment(dataFim).format("DD/MM/YYYY")}</span>
          </div>
        )}
        {profissionalSaude && (
          <div>
            Profissional:
            <span>{profissionalSaude?.nome}</span>
          </div>
        )}
        {convenio && (
          <div>
            Convênio:
            <span>{convenio?.descricao}</span>
          </div>
        )}
        {procedimento && (
          <div>
            Procedimento:
            <span>{procedimento?.descricao}</span>
          </div>
        )}
        {faturado && (
          <div>
            Faturado:
            <span>Sim</span>
          </div>
        )}
      </div>
      <div style={styles.headerColumn}>
        <div style={styles.columnProcedimento}>Procedimento</div>
        {utilizaValorCusto && <div style={styles.columnValorCusto}>Valor de custo</div>}
        <div style={styles.column}>Quantidade</div>
      </div>
      <div>
        {dadosRelatorio.map((item, index) => {
          return (
            <div
              key={item.id}
              style={{ ...styles.containerColuna, ...columnColor(index) }}
            >
              <div style={styles.columnProcedimento}>{item.procedimento}</div>
              {utilizaValorCusto && <div style={styles.columnValorCusto}>{item.valorCusto}</div>}
              <div style={styles.column}>{item.quantidade}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const styles = {
  titulo: {
    marginLeft: "0px",
    marginBottom: "10px",
    marginTop: "5px",
    paddingBottom: "5px",
    textAlign: "center",
    fontWeight: 700,
  },
  subTitulo: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #505050",
    marginBottom: "15px",
    paddingBottom: "5px",
    fontWeight: 700,
    justifyContent: "center",
    gap: "8px",
  },

  headerColumn: {
    display: "flex",
    flexDirection: "row",
    fontWeight: 700,
    width: "100%",
  },
  containerColuna: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  columnProcedimento: {
    width: "50%",
  },
  columnValorCusto: {
    width: "20%",
  },
  column: {
    width: "30%",
  },
};

export default RelatorioProcedimentosRealizadosContent;
